import { useState } from "react";
import { ChevronsLeftRight, Image as ImageIcon } from "lucide-react";

const Panel = ({ src, alt, placeholder }) =>
  src ? (
    <img src={src} alt={alt} loading="lazy" draggable={false} className="absolute inset-0 h-full w-full object-cover" />
  ) : (
    <div className="absolute inset-0 grid place-items-center bg-bati-mist">
      <div className="px-6 text-center">
        <ImageIcon className="mx-auto h-9 w-9 text-bati-blue/30" strokeWidth={1.5} />
        <p className="mt-4 font-display text-base font-bold text-bati-ink/50">{placeholder}</p>
        <p className="mt-1 text-xs text-bati-ink/35">Vraie photo BÂTI 360 à intégrer</p>
      </div>
    </div>
  );

const BeforeAfter = ({ before, after, className = "" }) => {
  const [pos, setPos] = useState(50);
  return (
    <div data-testid="before-after-slider" className={`relative select-none overflow-hidden ${className}`}>
      <Panel src={after} alt="Après travaux" placeholder="Photo APRÈS travaux — même chantier, même angle" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <Panel src={before} alt="Avant travaux" placeholder="Photo AVANT travaux — même chantier, même angle" />
      </div>
      <div className="pointer-events-none absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -left-px w-0.5 bg-white" />
        <div className="absolute top-1/2 grid h-12 w-12 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white shadow-[0_4px_20px_rgba(0,0,0,0.25)]">
          <ChevronsLeftRight className="h-5 w-5 text-bati-blue" />
        </div>
      </div>
      <span className="absolute left-4 top-4 bg-bati-ink/80 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-white">Avant</span>
      <span className="absolute right-4 top-4 bg-bati-blue px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-white">Après</span>
      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        data-testid="before-after-range"
        aria-label="Comparer avant et après travaux"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
    </div>
  );
};

export default BeforeAfter;
